import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routing, { RoutingProps } from '../utils/routes_ny';

export interface ServicetjekNyProps extends RoutingProps {
  baseUrl: string
}

const ServicetjekNy = (props: ServicetjekNyProps) => {
	return (
		<BrowserRouter basename={ props.baseUrl }>
			<Routing { ...props } />
		</BrowserRouter>
	);
};

export default ServicetjekNy;